import React, { useContext, useEffect, useRef, useState } from "react";
import Gallery from "@/components/detail/Gallery";
import { GlobalContext } from "@/context/globalContext";
import useWindowDimensions from "@/hooks/useWindowDimensions";
import { useOverflow } from "@/hooks/useOverflow";
import CloseButton from "../buttons/CloseButton";
import dynamic from "next/dynamic";
import SelectDates from "../detail/SelectDates";
import DetailHeader from "../detail/DetailHeader";
import AvailabilityCalendarButton from "../detail/AvailabilityCalendarButton";
import PriceSection from "../detail/PriceSection";
import VillaHeader from "../detail/VillaHeader";
import PricesSection from "@/components/detail/PricesSection";
import AboutSection from "@/components/detail/AboutSection";

const GavelLoginForm = dynamic(() => import("../modals/GavelLoginForm"), {
  ssr: false,
});

const AvailabilitySection = dynamic(
  () => import("@/components/detail/AvailabilitySection"),
  {
    ssr: false,
  }
);
const DistancesSection = dynamic(() =>
  import("@/components/detail/DistancesSection")
);
const VillaComments = dynamic(() =>
  import("@/components/detail/VillaComments")
);
const EditorComments = dynamic(() =>
  import("@/components/detail/EditorComments")
);
const AnimatedDiv = dynamic(() => import("../Bottombar/AnimatedDiv"), {
  ssr: false,
});
const ReservationRequestComponent = dynamic(
  () => import("@/components/detail/ReservationRequestComponent"),
  {
    ssr: false,
  }
);

const Detail = ({ villa }) => {
  const calendarRef = useRef(null);
  const scrollRef = useRef(null);
  const sectionRef = useRef(null);
  const width = useWindowDimensions(0);

  const [isVisible, setIsVisible] = useState(false);
  const [randomInt, setRandomInt] = useState(0);
  const [gavelLoginSuccess, setGavelLoginSuccess] = useState(false);
  const [isClient, setIsClient] = useState(false);
  const [result, setResult] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const { mobileBar, setMobileBar, bgShadow, setBgShadow } =
    useContext(GlobalContext);

  const CloseAll = () => {
    setMobileBar(false);
  };

  useEffect(() => {
    setBgShadow(mobileBar);
  }, [mobileBar]);

  useEffect(() => {
    if (bgShadow === false) CloseAll();
  }, [bgShadow]);

  const randomIntFromInterval = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
  };

  const updateRandomInt = () => {
    const rndInt = randomIntFromInterval(1, 5);
    setRandomInt(rndInt);
  };

  useEffect(() => {
    updateRandomInt();
    const interval = setInterval(updateRandomInt, 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  useOverflow(mobileBar);

  useEffect(() => {
    setGavelLoginSuccess(false);
    // view_item(villa);
  }, [villa?.id]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        root: null,
        threshold: 0.1,
        rootMargin: "200px",
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  if (
    villa?.gavel == "1" &&
    !gavelLoginSuccess &&
    villa?.gavelDetailOption == "1"
  ) {
    return (
      <GavelLoginForm
        setGavelLoginSuccess={setGavelLoginSuccess}
        emlak={villa?.id}
      />
    );
  }

  return (
    <div className="py-8 bg-white">
      <div className="container">
        <div className="flex flex-col justify-between mb-5 xsm:items-center xsm:flex-row xsm:mb-8">
          <DetailHeader villa={villa} />
          <div className="flex flex-col gap-2 xsm:gap-4">
            <PriceSection
              originalPrice={villa.minfiyat}
              Symbol={villa?.Symbol}
              discountedPrice={0}
            />
            <AvailabilityCalendarButton calendarRef={calendarRef} />
          </div>
        </div>
        <Gallery video={villa?.video} images={villa.photos} />
        <div className="flex flex-col gap-4 lg:flex-row">
          <div className="flex flex-col flex-1 lg:w-0">
            <VillaHeader views={randomInt} recentViews="24 saat" />
            <PricesSection villa={villa} randomInt={randomInt} />
            <AboutSection villa={villa} />
            <div ref={sectionRef} />
            <div id="availability">
              {isVisible && (
                <AvailabilitySection villa={villa} calendarRef={calendarRef} />
              )}
            </div>
            <div id="distances">
              {isVisible && <DistancesSection villa={villa} />}
            </div>
            <div id="reviews">
             {isVisible && <VillaComments comments={villa?.comments} villaId={villa?.id} />}
            </div>
            {villa?.editor_yorumlari && (
              <div id="editorComments">
              {isVisible && <EditorComments content={villa?.editor_yorumlari} />}
              </div> 
            )}
          </div>
          <div className="lg:w-[357px] w-full">
            {width > 1024 && (
              <ReservationRequestComponent
                villa={villa}
                scrollRef={scrollRef}
                result={result}
                setResult={setResult}
              />
            )}
          </div>
        </div>
      </div>
      {isClient && mobileBar === "reservationForm" && (
        <AnimatedDiv animate="open">
          <CloseButton CloseAll={CloseAll} />
          <div
            className={`flex flex-col overflow-y-auto ${
              !result.success ? "h-[calc(40vh)]" : "h-[calc(75vh)]"
            }`}
          >
            <ReservationRequestComponent
              villa={villa}
              scrollRef={scrollRef}
              result={result}
              setResult={setResult}
            />
          </div>
        </AnimatedDiv>
      )}
      <SelectDates />
    </div>
  );
};

export default Detail;
